import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BaseService } from './base.service';
import { IWidgetResolverHttpService } from './widget/widget-resolver-http-service';
import { MappedArea } from 'src/objects/mapped-area';
import { Destination } from 'src/objects/destination';


@Injectable({
  providedIn: 'root'
})
export class MappedAreaService
  extends BaseService
  implements IWidgetResolverHttpService<MappedArea> {
  createInstance = (attributes: MappedArea): MappedArea => attributes;

  get(slugOrId: string | number): Observable<MappedArea> {
    return this.http
      .get<MappedArea>(`${this.baseUrl}/public/mapped_areas/${slugOrId}`);
  }

  getAll(args: { destination: Destination }): Observable<MappedArea[]> {
    const { destination } = args;
    const url = `${this.baseUrl}/public/mapped_areas`;
    
    const params = { destination_id: `${destination.id}`};

    return this.getPagedRequest<MappedArea, MappedArea>({ url, params });
  }
}
